interface IAjaxError<R = unknown> extends Error {
  message: string;
  status: number;
  response: R;
}

export class AjaxError implements IAjaxError {
  message: string;
  status: number;
  response: any;
  name: string;

  constructor(errorStatus: number, response: any) {
    this.status = errorStatus;
    this.message = response?.message ?? "";
    this.response = response;
    this.name = "Ajax Error";
  }
}
